<script lang="ts" setup>
import type { EmailContact } from '~~/server/api/officeservice/services/[slug]'

export type PagesOfficesDetailContactProps = {
    phoneContacts: PhoneContact[]
    emailContacts?: EmailContact[]
    cardPay: boolean
    showCardPayBox: boolean
    showPhoneNumbers?: boolean
    type: string
}

const props = defineProps<PagesOfficesDetailContactProps>()
const { $t } = useNuxtApp()

const title = $t('Kontaktné údaje')
</script>
<template>
  <PagesOfficesDetailBox>
    <section
      v-if="(props.showPhoneNumbers || props.type === 'services') && (props.phoneContacts?.length || props.emailContacts?.length)"
      :class="{ 'mb-8': props.showCardPayBox }"
    >
      <Tracker :data="{ position: title }">
        <h2 class="delta mb-4">
          {{ title }}
        </h2>
        <ul
          v-if="props.phoneContacts.length"
          class="d-flex flex-column gap-4"
        >
          <PagesOfficesDetailContactItem
            v-for="(item, index) in props.phoneContacts"
            :key="`pni-${index}`"
            :link="`tel:${item.international_format}`"
            :label="item.international_format"
            :note="item.note"
            icon-key="phone"
          />
        </ul>
        <ul
          v-if="props.emailContacts && props.emailContacts.length"
          class="mt-4 d-flex flex-column gap-4"
        >
          <PagesOfficesDetailContactItem
            v-for="(item, index) in props.emailContacts"
            :key="`pni-${index}`"
            :link="`mailto:${item.email}`"
            :label="item.email"
            :note="item.note"
            icon-key="email"
          />
        </ul>
      </Tracker>
    </section>
    <section v-if="props.showCardPayBox">
      <h3
        class="delta"
        :aria-label="`${$t('Ďalšie informácie')}`"
      >
        {{ $t('Ďalšie informácie') }}
      </h3>
      <p class="d-flex align-items-center fs-bigger">
        <template v-if="props.cardPay">
          <svg
            class="d-block me-3 text-secondary"
            width="20"
            height="20"
            aria-hidden="true"
          >
            <use xlink:href="#cardpayyes" />
          </svg>
          {{ $t('Je možné platiť kartou') }}
        </template>
        <template v-else>
          <svg
            class="d-block me-3 text-secondary"
            width="20"
            height="20"
            aria-hidden="true"
          >
            <use xlink:href="#cardpayno" />
          </svg>
          {{ $t('Nie je možné platiť kartou') }}
        </template>
      </p>
    </section>
    <IconsWrapper>
      <IconsSymbolPhone />
      <IconsSymbolCardpayNo />
      <IconsSymbolCardpayYes />
      <IconsSymbolEmail />
    </IconsWrapper>
  </PagesOfficesDetailBox>
</template>
